import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute from "@/components/ProtectedRoute";
import DashboardLayout from "@/components/DashboardLayout";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Overview from "@/pages/Overview";
import AdminPanel from "@/pages/AdminPanel";
import Patients from "@/pages/Patients";
import PatientDetail from "@/pages/PatientDetail";
import Treatments from "@/pages/Treatments";
import Payments from "@/pages/Payments";
import Expenses from "@/pages/Expenses";
import Staff from "@/pages/Staff";
import Appointments from "@/pages/Appointments";
import Reports from "@/pages/Reports";
import Messages from "@/pages/Messages";
import Invoices from "@/pages/Invoices";

function DashboardHome() {
    const { user } = useAuth();
    if (user?.role === "super_admin")
        return <Navigate to="/dashboard/admin" replace />;
    return <Overview />;
}

function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Toaster position="top-right" richColors />
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/login" element={<Login />} />
                    <Route
                        path="/dashboard"
                        element={
                            <ProtectedRoute>
                                <DashboardLayout />
                            </ProtectedRoute>
                        }
                    >
                        <Route index element={<DashboardHome />} />
                        <Route
                            path="admin"
                            element={
                                <ProtectedRoute roles={["super_admin"]}>
                                    <AdminPanel />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="patients"
                            element={
                                <ProtectedRoute roles={["patron", "staff"]}>
                                    <Patients />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="patients/:id"
                            element={
                                <ProtectedRoute roles={["patron", "staff"]}>
                                    <PatientDetail />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="treatments"
                            element={
                                <ProtectedRoute roles={["patron", "staff"]}>
                                    <Treatments />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="payments"
                            element={
                                <ProtectedRoute roles={["patron", "staff"]}>
                                    <Payments />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="expenses"
                            element={
                                <ProtectedRoute roles={["patron", "staff"]}>
                                    <Expenses />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="appointments"
                            element={
                                <ProtectedRoute roles={["patron", "staff"]}>
                                    <Appointments />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="reports"
                            element={
                                <ProtectedRoute roles={["patron", "staff"]}>
                                    <Reports />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="messages"
                            element={
                                <ProtectedRoute roles={["patron", "staff"]}>
                                    <Messages />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="invoices"
                            element={
                                <ProtectedRoute roles={["patron", "staff"]}>
                                    <Invoices />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="staff"
                            element={
                                <ProtectedRoute roles={["patron"]}>
                                    <Staff />
                                </ProtectedRoute>
                            }
                        />
                    </Route>
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </BrowserRouter>
        </AuthProvider>
    );
}

export default App;
